import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Typography, Card, CardHeader, CardContent } from '@material-ui/core';
import IconSad from '@material-ui/icons/SentimentDissatisfied'
export class NotFound extends Component {
    static displayName = NotFound.name;

    render() {
        return (
            <Card><CardHeader avatar={<IconSad fontSize='large' />} title={<Typography variant="h5" component="h3">Ľutujeme, ale požadovaná stránka nebola nájdená!
                </Typography>} />

                {localStorage.getItem('user') === null &&
                    <CardContent>
                        <Typography variant='body2' component='div'>Pre využitie funkcií stránky je požadované <Link to='/Login'> prihlásenie</Link></Typography>
                    </CardContent>
                }
            </Card >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js